import * as types from "./types";
import * as selectors from "./selectors";

const fetchLocaleRequest = locale => ({
  type: types.FETCH_LOCALE_REQUEST,
  locale
});
const fetchLocaleSuccess = (locale, translations) => ({
  type: types.FETCH_LOCALE_SUCCESS,
  locale,
  translations
});
const fetchLocaleFailure = (locale, error, fallbackLocale) => ({
  type: types.FETCH_LOCALE_FAILURE,
  locale,
  error,
  fallbackLocale
});

export const fetchLocale = languageKey => async (dispatch, getState) => {
  const state = getState();
  if (selectors.shouldFetchLocale(state, languageKey)) {
    dispatch(fetchLocaleRequest(languageKey));
    window.i18n.changeLocale(languageKey, translations => {
      dispatch(fetchLocaleSuccess(languageKey, translations));
    });
  }
};
